import Image, { StaticImageData } from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import Link from 'next/link';
import BabyImg from './images/baby-blog.png';
import BabyMommyImg from './images/mom-baby-blog.png';
import FoodImg from './images/food-blog.png';
import YellowMonsterImg from '../cover/images/YellowMonster.png';
import GreenCirculeImg from './images/green-circule.png';
import { ReactComponent as Arrow } from './images/arrow.svg';

interface BlogCardProps {
  key: string;
  img: StaticImageData;
  children: React.ReactNode;
  href: string;
}

function BlogSectionCard({ img, children, href }: BlogCardProps) {
  return (
    <div className="flex flex-col flex-none w-[290px] h-[344px] xl:h-[400px] xl:w-[380px] pt-6 px-5 pb-5 bg-white rounded-3xl">
      <div className="flex flex-col">
        <div className="mb-5">
          <Image src={img} alt="cover" />
        </div>
        <h4 className="text-body">{children}</h4>
      </div>
      <div className="mt-auto w-[180px] h-[48px] bg-green rounded-full uppercase text-body font-semibold text-sm flex items-center justify-center">
        <Link href={href}>
          <a>Read more</a>
        </Link>
      </div>
    </div>
  );
}

const AllBlogCards: BlogCardProps[] = [
  {
    key: 'card1',
    img: BabyImg,
    children: 'I tested my baby’s poop. Here’s why.',
    href: 'https://snapihealth.medium.com/i-tested-my-babys-poop-here-s-why-e4cf6c1c575f',
  },
  {
    key: 'card2',
    img: FoodImg,
    children: 'Infant Gut Microbiome Testing Is The Future.',
    href: 'https://snapihealth.medium.com/infant-gut-microbiome-testing-is-the-future-2b51877fdbfe',
  },
  {
    key: 'card3',
    img: BabyMommyImg,
    children: 'Why is my baby’s gut health important?',
    href: 'https://snapihealth.medium.com/why-is-my-babys-gut-health-important-50a8c8ce080d',
  },
];

export function BlogSectionScience() {
  return (
    <section id="blog-section-science" className="relative flex flex-col">
      <div className="absolute top-[-100px] left-[-10px] w-[42px] sm:w-[80px] sm:top-[-230px] sm:left-[-20px] xl:w-[90px] xl:left-0">
        <Image src={GreenCirculeImg} alt="" />
      </div>
      <div className="container relative">
        <div className="sm:flex">
          <h2 className="mb-5 sm:mr-8">Interested in learning more?</h2>

          <Link href="https://snapihealth.medium.com/">
            <a className="cursor-pointer font-semibold flex justify-center items-center mb-10 w-[200px] h-[40px] border-[1px] rounded-full border-body uppercase">
              Open in medium
              <div className="ml-2">
                <Arrow />
              </div>
            </a>
          </Link>
        </div>
        <div className="absolute top-[60px] sm:top-0 right-0 w-[140px]">
          <Image src={YellowMonsterImg} alt="" />
        </div>
      </div>
      <div className="relative w-full pl-3 sm:pl-10 lg:pl-0 lg:w-[930px] xl:w-[1200px] mx-auto z-10">
        <Swiper
          slidesPerView="auto"
          spaceBetween={30}
          loop={true}
          pagination={{
            enabled: true,
            clickable: true,
            type: 'bullets',
            bulletElement: 'span',
            el: '#blog-pagination',
            bulletActiveClass: 'bg-body opacity-100',
          }}
          modules={[Pagination]}
        >
          <>
            {AllBlogCards.map((card) => (
              <SwiperSlide key={card.key} className="w-[290px] xl:w-[380px]">
                {(data) => (
                  <div className="flex flex-none ">
                    <BlogSectionCard {...card} />
                  </div>
                )}
              </SwiperSlide>
            ))}
          </>
        </Swiper>
        <div
          id="blog-pagination"
          className="absolute flex flex-1 justify-center bottom-[-50px] inset-x-0 gap-2 md:hidden"
        ></div>
      </div>
    </section>
  );
}
